<template>
  <v-container>
    <v-row justify="center">
      <v-col v-if="loading">
        <helmi-loader
          background-color="grey lighten-4"
          :loading="loading"
        />
      </v-col>
      <v-card
        v-if="!loading"
        max-width="900"
        style="width: 100%;"
        :class="{ 'file-sign-list-width': $vuetify.breakpoint.smAndUp }"
        class="mt-8"
      >
        <v-card-text :class="{ 'px-6 pt-5': $vuetify.breakpoint.mdAndUp }">
          <div v-if="propertyName">
            {{ propertyName }}
          </div>
          <p class="text-h5 text--primary mb-0">
            Toimeksiannon sopimukset
          </p>
        </v-card-text>
        <v-card
          outlined
          class="mx-5 mb-4"
        >
          <v-list
            two-line
            subheader
            class="pb-0"
          >
            <template v-if="currentProperty && currentProperty.buyorder > 0">
              <v-list-item
                @click="goToBuyOrder(currentProperty.buyorder)"
              >
                <v-list-item-avatar>
                  <v-icon class="blue" dark>
                    assignment
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Ostotoimeksiantosopimus</v-list-item-title>
                  <v-list-item-subtitle>
                    <!-- {{ allAgreements[id].form_data_agreement.created | date }} -->
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-else>
              <v-list-item
                v-if="allAgreements[id] && allAgreements[id].form_data_agreement"
                @click="goToAgreement('agreement')"
              >
                <v-list-item-avatar>
                  <v-icon class="blue" dark>
                    assignment
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Toimeksiantosopimus</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ allAgreements[id].form_data_agreement.created | date }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-else @click="createAgreement('agreement')">
                <v-icon color="blue" class="mr-3">
                  add_box
                </v-icon>
                <v-list-item-content>
                  <v-list-item-title>Luo toimeksiantosopimus</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="allAgreements[id] && allAgreements[id].form_data_additional"
                @click="goToAgreement('additional')"
              >
                <v-list-item-avatar>
                  <v-icon class="blue" dark>
                    assignment
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Selostusliite</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ allAgreements[id].form_data_additional.created | date }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-else @click="createAgreement('additional')">
                <v-icon color="blue" class="mr-3">
                  add_box
                </v-icon>
                <v-list-item-content>
                  <v-list-item-title>Luo selostusliite</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="allAgreements[id] && allAgreements[id].form_data"
                @click="goToAgreement()"
              >
                <v-list-item-avatar>
                  <v-icon class="blue" dark>
                    assignment
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Toimeksiantosopimus ja selostusliite</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ allAgreements[id].form_data.created | date }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-else @click="createAgreement()">
                <v-icon color="blue" class="mr-3">
                  add_box
                </v-icon>
                <v-list-item-content>
                  <v-list-item-title>Luo toimeksiantosopimus ja selostusliite</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
        <v-card
          outlined
          class="mx-5 mb-4"
        >
          <v-list
            two-line
            subheader
            class="pb-0"
          >
            <v-subheader class="secondary--text">
              MUUT SOPIMUSMENETTELYT
            </v-subheader>
            <v-divider/>
            <template
              v-for="item in processList"
            >
              <v-list-item
                :key="item.id"
                @click="goToProcess(item.id)"
              >
                <v-list-item-avatar>
                  <v-icon
                    class="secondary white--text"
                  >
                    file_copy
                  </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-text="item.name"/>
                  <v-list-item-subtitle v-text="item.property_name"/>
                  <v-list-item-subtitle
                    v-if="item.create_date"
                    v-text="formatDate(item.create_date)"
                  />
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="`${item.id}_`"/>
            </template>
            <v-list-item @click="newFileSigningProcess()">
              <v-icon color="blue" class="mr-3">
                add_box
              </v-icon>
              <v-list-item-content>
                <v-list-item-title>Luo muu sopimusmenettely</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-card>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import { apiGet } from '../api';

export default {
  name: 'FileSignList',

  components: {
    'helmi-loader': () => import('@/components/formElements/Loader'),
  },
  data: () => ({
    processList: [],
    propertyName: '',
    loading: true,
  }),
  computed: {
    ...mapState({
      commissionAgreements: state => state.commissionAgreement.byId,
      allAgreements: state => state.allAgreements.byId,
      companyId: state => state.userDetails.companyPath,
      currentProperty: state => state.currentProperty,
    }),
    id() {
      return this.$route.params.id;
    },
    agreement() {
      if (this.commissionAgreements
        && this.commissionAgreements[this.id]
        && this.commissionAgreements[this.id].created
      ) {
        return this.commissionAgreements[this.id].created;
      }
      return false;
    },
  },
  async mounted() {
    if (this.id) {
      await this.getPropertyProcessList();
      const response = await apiGet(`properties/basicdetails/${this.id}`);
      if (response.result && response.result.kohdenimi) {
        this.propertyName = response.result.kohdenimi;
      }
      // await this.getAgreement({ id: this.id });
      await this.getAllAgreements({ id: this.id });
    } else {
      await this.getProcessList();
    }
    this.loading = false;
  },
  methods: {
    ...mapActions({
      setCurrentProperty: 'setCurrentProperty',
      getAgreement: 'commissionAgreement/getOne',
      getAllAgreements: 'allAgreements/getOne',
    }),
    goToBuyOrder(id) {
      this.$router.push({ name: 'buyorder', params: { id, companyId: this.companyId } });
    },
    goToAgreement(side) {
      if (side) {
        this.$router.push({ name: 'commissionAgreementPreview', params: { id: this.id, companyId: this.companyId, side } });
      } else {
        this.$router.push({ name: 'commissionAgreementPreview', params: { id: this.id, companyId: this.companyId } });
      }
    },
    createAgreement(side = null) {
      const params = { id: this.id, companyId: this.companyId };
      if (side) {
        params.side = side;
      }
      this.$router.push({ name: 'commissionAgreement', params });
    },
    async getProcessList() {
      const response = await apiGet('dropbox/processlist');
      this.processList = response.result;
    },
    formatDate(date) {
      if (!date) return null;
      return moment(date).format('DD.MM.YYYY HH:mm');
    },
    async getPropertyProcessList() {
      const response = await apiGet(`dropbox/propertyprocesslist/${this.id}`);
      this.processList = response.result;
      await this.setCurrentProperty(this.id);
    },
    goToProcess(id) {
      this.$router.push(`/signfiles/${id}`);
    },
    newFileSigningProcess() {
      this.$router.push(`/signfiles/new/${this.id}`);
    },
  },
};
</script>
<style lang="scss">
  .file-sign-list-width {
    width: 100%;
    max-width: 600px;
  }
</style>
